import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { ChartsService } from '../../services/charts.service';

// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import 'chart.piecelabel.js';
import { Router } from '@angular/router';
import { ChartConfiguration,ChartType, ChartTypeRegistry } from 'chart.js';

interface IRow {
  timestamp: string;
  preBookedCount: number;
  didntPrebookedCount: number;
  preBookedPercentage: number;
}
interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  pie: ChartType;
  // ... other chart types
};

@Component({
  selector: 'app-prebooking-report',
  templateUrl: './prebooking-report.page.html',
  styleUrls: ['./prebooking-report.page.scss'],
})
export class PrebookingReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public cols: primeNgCol[];

  public stylistID: number;

  public stylist: Stylist;

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public groupBy: string;

  public pieChartLabels: string[] = ['Prebooked', 'Did not prebook'];

  public pieChartData: ChartConfiguration<'pie'>['data'] = {
    labels: this.pieChartLabels,
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#EC6B56', '#FFC154'],
        borderColor: ['#333', '#333'],
      },
    ],
  };

  public pieChartType: keyof MyChartTypeRegistry = 'pie';

  public pieChartColor: { backgroundColor: string[]; borderColor: string[] }[];

  public pieChartOptions: Object;

  constructor(
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService,
    private router: Router
  ) // ,
  // private googleAnalytics: GoogleAnalytics
  {
    this.stats = [];
    this.cols = [
      { field: 'timestamp', header: 'Date' },
      { field: 'preBookedCount', header: '# Prebooked' },
      { field: 'didntPrebookedCount', header: "# Didn't" },
      { field: 'preBookedPercentage', header: '% Prebooked' },
    ];

    this.pieChartColor = [ChartsService.pieChartColor('#EC6B56', '#FFC154')];
    this.pieChartOptions = ChartsService.pieChartOptions('top');

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() ||
        user.getCanViewReports() === 1 ||
        user.getViewAllClients() === 1
      );
    }
  }



  public ngOnInit() {
    // this.googleAnalytics.trackView('PreBookingReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.groupBy) {
      let dateFromCache: string = localStorage.getItem('groupBy');

      if (dateFromCache) {
        this.groupBy = dateFromCache;
      } else {
        this.groupBy = 'daily';
      }
    }
  }
  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
    }
  }
  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.groupBy = dateRange.groupBy;
    this.timeManager(dateRange.start, dateRange.end);
    this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
  }

  public loadStats(
    stylist: Stylist,
    startDate: Date,
    endDate: Date,
    groupBy: string = 'daily'
  ) {
    this.timeManager(startDate, endDate);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.pieChartData.datasets[0].data = [];
    this.reportService
      .loadPreBooking(stylist.id, startDate, endDate, groupBy)
      .subscribe({
        next: (rows) => {
          const stats: Array<IRow> = [];

          let prebookedOverallTotal: number = 0;
          let overallClientTotal: number = 0;

          rows.forEach((row) => {
            let preBookedPercentage = 0;
            let didntPrebookedCount = row.clientCount - row.preBookedCount;

            if (row.clientCount > 0) {
              preBookedPercentage = Utilities.roundTo2Decimal(
                (row.preBookedCount / row.clientCount) * 100
              );
            }

            let timestamp: string = '';

            if (this.groupBy === 'daily') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'ddd, MMMM D, Y'
              );
            } else if (this.groupBy === 'weekly') {
              timestamp = row.timestamp;
            } else if (this.groupBy === 'monthly') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'MMMM'
              );
            }

            stats.push({
              timestamp: timestamp,
              preBookedCount: row.preBookedCount,
              didntPrebookedCount: didntPrebookedCount,
              preBookedPercentage: Math.round(preBookedPercentage),
            });

            prebookedOverallTotal += row.preBookedCount;
            overallClientTotal += row.clientCount;
          });

          let overallPrebookedTotal: number = 0;
          let overallDidntPrebookTotal: number = 0;

          if (overallClientTotal > 0) {
            overallPrebookedTotal =
              (prebookedOverallTotal / overallClientTotal) * 100;
            overallDidntPrebookTotal = 100 - overallPrebookedTotal;
          }

          this.pieChartData.datasets[0].data = [
            Number(overallPrebookedTotal.toFixed(2)),
            Number(overallDidntPrebookTotal.toFixed(2)),
          ];
          this.stats = stats;
          this.isLoading = false;
          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          // this.content.resize();
        },
      });
  }

  public timeManager(dateRangeStart, dateRangeEnd) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;
  }

  public exportPdf() {
    this.ExportTableService.exportPdf(this.stats, 'Prebookings', this.cols);
  }

  public exportExcel() {
    this.ExportTableService.exportExcel(
      this.stats,
      'Prebookings',
      this.cols.map((col) => col.header)
    );
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
